module.exports = __webpack_public_path__ + "img/03.9d4259ee.jpg";